import routes from 'global/Constants/routes';

import { lazy } from 'react';

const UserProfile = lazy(() => import('../../pages/dashboard/profile/components/UserProfile'));
const PersonBankAccount = lazy(() => import('../../pages/dashboard/user/personBankAccount/PersonBankAccount'));
const PersonBusinessProfile = lazy(() => import('../../pages/dashboard/user/personBusinessProfile/PersonBusinessProfile'));

export const userRoutes = (hasAccessLevel: (_level: number) => boolean) => [
  {
    path: routes.userProfile.path,
    component: UserProfile,
    isPrivate: routes.userProfile.isPrivate,
    accessRole: hasAccessLevel(10),
  },
  {
    path: routes.personBankAccount.path,
    component: PersonBankAccount,
    isPrivate: routes.personBankAccount.isPrivate,
    accessRole: hasAccessLevel(10),
  },
  {
    path: routes.personBusinessProfile.path,
    component: PersonBusinessProfile,
    isPrivate: routes.personBusinessProfile.isPrivate,
    accessRole: hasAccessLevel(10),
  },
];
